// Call plugin.
import * as actionTypes from '../actionTypes'

// Libraries.
import { handleActions } from 'redux-actions'

/**
 * The devices substate keeps tracks the of the media devices available for use.
 */
const reducers = {}

// Replace old devices with newly checked devices.
reducers[actionTypes.SET_BROWSER_DETAILS] = {
  next (state, action) {
    return action.payload
  }
}

const reducer = handleActions(reducers, {})
export default reducer
